/* eslint-disable global-require */
const List = () => import(/* webpackChunkName: "atendimento" */ './main.vue');
const Search = () => import(/* webpackChunkName: "atendimento" */ './search.vue');

export default [
  {
    name: 'atendimentos',
    path: '/atendimentos',
    components: { default: List, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Atendimento',
      icon: 'heartbeat',
      can: 'list',
      on: 'atendimento',
      neto: true,
    },
  },
];
